import { messageByJob } from './messageByJob';
import { bulkCancelJobRequest, bulkCancelJobRequestV2 } from './bulkCancelJobRequest';
import { preferredTeam } from './preferredTeam';

export default {
  bulkCancelJobRequest,
  messageByJob,
  preferredTeam,
  bulkCancelJobRequestV2,
  wonoloers: {
    blockWonoloersModal: {
      title: 'Block Wonoloer',
      confirm: 'Confirm',
      cancel: 'Cancel',
      blockIconText: 'Block worker',
      commentsPlaceholder: 'Please specify the reason for blocking',
      modalContent: {
        header: 'Block %wonoloerName% from all future jobs at your company?',
        sentence1:
          '- They will not be able to see any jobs your company posts.',
        sentence2p1: `- They will be cancelled from all existing jobs that they have accepted with
                        your company through other Users. (This will NOT cancel jobs that are
                        within `,
        sentence2p2: ' from start time).',
        sentence3: '- They will not know that you blocked them.',
        header2: 'Please let us know how this Wonoloer can improve:',
        professionalism: 'Professionalism',
        punctuality: 'Punctuality',
        politeness: 'Politeness',
        preparedness: 'Preparedness',
        positivity: 'Positivity',
        other: 'Other',
      },
      newBlockModal: {
        subHeader:
          'Tell us why you no longer want %firstName% to be able to accept future jobs at %customerName%.',
        arrivedLate: 'Arrived late or left early',
        dressCode: 'Did not meet the dress code or grooming requirements',
        attitude: 'Disrupted the workplace',
        notFit: 'Did not meet job requirements',
        unproductive: 'Failed to complete job on time',
        instructions: 'Did not possess necessary skills',
        other: 'Other',
      },
    },
    absentModal: {
      messageWonoloer: 'Message %firstName% (recommended)',
      excuseAbsence: 'Mark as an excused absence',
      markNoShowFirst: "Mark 'No call, no show'",
      markNoShowSecond: 'This will limit their access to all jobs',
      noShow: 'No show',
      useCorrectly: 'Please use this correctly. By submitting as a ‘no show’, %firstName%’s opportunities to access jobs become restricted',
      markNoShow: "Mark as 'no call, no show'",
      markNoShowHint: "Please use this correctly. By selecting this option, %firstName%'s opportunities to access jobs become restricted.",
      back: 'Back',
      submit: 'Submit',
      confirm: 'Confirm',
      initialView: {
        headerText: 'Is %firstName% Absent?',
      },
      excuseAbsenceView: {
        inputPlaceholder: 'Tell me why ...',
        headerText: 'What is the reason for the excused absence?',
        headerGroup: 'Excuse reason',
        dressCodeCheck: 'Check this box if the worker did not meet the dress code or grooming requirements',
        submitButtonText: 'Submit excuse',
        excuseReasonLabel: 'Excuse reason',
      },
      noShowView: {
        headerText: 'Do you want to report %firstName% as a ‘no show’',
        dressCodeCheck: 'Check this box if this is related to dress code or grooming issues',
        submitButton: 'Submit as ‘No show’'
      },
      redBanner: {
        knownLocation:
          'Our system indicates that %firstName% was within a mile radius of the job site %min% minutes ago.',
        clockInAt:
          'Our system indicates that %firstName% clocked in at %clockInAt%',
        clockOutAt: ' and clocked out at %clockOutAt%.',
      },
    },
    messageModal: {
      loadMore: 'Load More',
      scrollToBottom: 'Scroll to bottom',
      messageAllSuccess:
        'Your message was delivered to %numWonoloers% Wonoloers.',
      notDelivered: 'Not Delivered',
    },
  },
  cancelJobsModal: {
    header: 'Cancel Wonoloer',
    warningMessage:
      'Please note that cancellations within 12 hours of the job will result in cancellation fees worth 50% of the Wonoloer’s pay, in accordance with Wonolo’s Customer Agreement.',
    warningMessageV2: 'Please note that cancellations within 12 hours of the job may result in cancellation fees worth 50% of the Wonoloer’s pay, in accordance with Wonolo’s Customer Agreement.',
    cancellingDays: 'Canceling %days% days',
    cancelDay: 'Canceling 1 day',
    form: {
      header: 'Reason for Cancellation',
      optionNone: 'None',
      optionWonoloer: 'Wonoloer asked me to cancel',
      optionOther: 'Other',
      placeholder: 'Write reason...',
      backfill: 'Backfill position (Recommended)',
      backfillWarning: 'This position will not be backfilled',
    },
    inprogress:
      "Your job cancellation request is processing. You'll be notified when it completes.",
    error:
      'Your job cancellation request cannot be completed. Please try again later.',
    intro: {
      step1:
        'Have your labor needs changed? You can reduce the number of Wonoloers needed through “Edit Job”, which keeps your Favorited and Preferred Wonoloers - no need to cancel them one by one.',
    },
    jobsCalendar: {
      selectShifts: 'Select Days for Cancellation',
      selectAll: 'Select All'
    }
  },
  cancelJobRequestModal: {
    header: 'Cancel Job',
    workersCancelled: '%numberOfWorkers% Wonoloers will be cancelled',
    workerCancelled: '%numberOfWorkers% Wonoloer will be cancelled',
    form: {
      provideReason: 'Provide Reason',
      optionOtherPlaceholder: 'Write reason...',
      optionOther: 'Other',
      optionLaborNeeds: 'My labor needs have changed',
      optionMadeMistake: 'I made a mistake when posting job',
      error: 'Reason must be provided'
    },
    warningMessage:
      'Please note that cancellations within 12 hours of the job will result in cancellation fees worth 50% of the Wonoloer’s pay, in accordance with Wonolo’s Customer Agreement.',
    warningMessageV2: 'Please note that cancellations within 12 hours of the job may result in cancellation fees worth 50% of the Wonoloer’s pay, in accordance with Wonolo’s Customer Agreement.',
  },
  toasts: {
    block: '%workerName% is blocked from future jobs.',
    unblock: '%workerName% is unblocked from future jobs.',
    error: 'System error. Please try again later.',
  },
  // @todo where should this live
  unblockWonoloersButton: {
    unblockIconText: 'Unblock',
  },
  adjustModal: {
    popper: {
      clockInText: 'Clock In: %time%',
      clockOutText: 'Clock Out: %time%',
      within: 'Within 1mi radius of worksite',
      outside: 'Outside 1mi radius of worksite',
    },
    tooltips: {
      coveredCosts: "Wonoloer's out-of-pocket costs covered by this job.",
      flatRate:
        "Wonoloer's pay based on task completion. Pay is not typically adjusted so long as the Wonoloer completes all job requirements.",
    },
    placeholders: {
      multi: 'Multi',
      adjustReason: 'Write reason for adjustment (required)',
      coveredCostsReason: 'Write reason for covered costs (required)',
    },
    headers: {
      adjust: 'Adjust Time & Pay',
      addCoveredCosts: 'Add Covered Costs',
    },
    subheaders: {
      break:
      '%startDate%, %inTime% - %endDateText%%outTime%, %unpaidBreakTime% Unpaid Break',
      flatRate:
      '%startDate%, %inTime% - %endDateText%%outTime%, $%flatRate% Flat Rate',
    },
    labels: {
      coveredCosts: 'Covered Costs',
      clockIn: 'Clock In',
      clockOut: 'Clock Out',
      estimatedPay: 'Estimated Time & Pay',
      flatRate: 'Flat Rate',
      breaks: {
        autoDeductedTitle: '%duration% min unpaid break was auto deducted',
        adjustedBreakTitle: '%duration% minute unpaid break',
      }
    },
    breaks: {
      addBreak: 'Add Break',
      editBreak: 'Edit Break',
      deleteBreak: 'Delete Break'
    },
    descriptions: {
      jobId: 'Job ID: %jobId%',
      initialClockIn: 'Original Clock In: %clockInTime%',
      initialClockOut: 'Original Clock Out: %clockOutTime%',
      initialBreakStart: 'Initial Start: Automatic',
      initialBreakEnd: 'Initial End: Automatic'
    },
    estimatedPay: {
      wonoloerPay: 'Wonoloer Pay (%hours%h %minutes%m @ %rate%/hr)',
      wonoloerPayFlatRate: 'Wonoloer Pay (Flat Rate)',
      covered: 'Covered costs',
      service: 'Service charge',
      total: 'Total',
    },
    validationErrors: {
      clockOut: 'Clock In time must be before Clock Out.',
      flatRate: 'This needs to be at least %percent%% of the original pay',
      flatRateRequired: 'Flat Rate Required',
      amountMax: 'You cannot adjust pay higher than $100,000',
      adjustReason: 'Please write a reason for adjustment.',
      coveredCostsReason: 'Please write a reason for covered costs.',
      coveredCosts: 'Please enter a valid value for covered costs.',
      belowThreshold:
        'Calculated adjusted pay needs to be at least %percent%% of the scheduled hours pay.',
      adjustTimeInFuture: 'Cannot adjust clock out to future time',
      breaksIncomplete: 'Please complete break start and end time',
      breakStartBeforeClockIn: 'Break start time cannot be before clock-in time',
      breakStartAfterClockOut: 'Break start time cannot be after clock-out time',
      breakEndAfterClockOut: 'Break end time cannot be after clock-out time',
      breakEndBeforeClockIn: 'Break end time cannot be before clock-in time',
      breakEndBeforeBreakStart: 'Break end time cannot be before break start time.',
      breaksLongerThanOrEqualJobDuration: 'Break start and end time duration cannot be longer or equal to clock-in and clock-out duration.'
    },
    serverError: 'Oops, there was a server error. Please try again later.',
    legacyModalText:
      "To edit the Wonoloer's pay for this job, please edit the Flat Rate.",
    intro: {
      step1:
        'Pay automatically adjusts based on the Wonoloers Clock In and Clock Out times.',
      step2:
        'You can manually adjust pay by changing the Clock In or Clock Out times if needed. ',
    },
    pendingMessage:
      "%num% jobs are awaiting adjustment from our system. You'll be notified when they're done.",
    pendingMessageSingle:
      "1 job is awaiting adjustment from our system. You'll be notified when it's done.",
  },
  jobDetails: {
    title: 'Details',
    subheaderWithBreak:
      '%startDate%, %startTime% - %endDate%%endTime%, %unpaidBreakTime% Unpaid Break',
    subheaderWithFlatRate:
      '%startDate%, %startTime% - %endDate%%endTime%, %flatRate% Flat Rate',
    finalPay: 'Final Pay',
    jobHistory: 'Job History',
    jobId: 'Job ID',
    states: {
      approved: 'Approved',
      completed: 'Clocked Out',
      in_progress: 'Clocked In',
      filled: 'Accepted',
      posted: 'Posted',
      no_show: 'No Show',
      withdrawn: 'Withdrawn'
    }
  },
  exportRoster: {
    title: 'You are about to leave this page',
    description: {
      part1: 'You will be taken to',
      part2: 'where you can export the roster.',
    },
    buttons: {
      cancel: 'Cancel',
      continue: 'Continue'
    }
  },
  teamDetailsModal: {
    title: 'Manage Team',
    label: {
      teamName: 'Team Name',
      search: 'Search Wonoloers',
    },
    searchPlaceholder: 'First or Last Name',
    table: {
      teamMember: 'TEAM MEMBER',
      lastWorked: 'LAST WORKED',
      wonoloer: 'WONOLOER',
    },
    emptyLastWorked: '--',
    noTeamMembers: {
      header: 'No Team Members',
      body: 'Select from the list below to add'
    },
    noWonoloers: {
      header: 'No Wonoloers',
      body: 'Here is where you find them'
    },
    noResults: {
      header: 'No Wonoloers Found',
      body: 'Try changing your search term'
    },
    blankNameError: "Team name can't be blank",
    updateSuccess: 'Your team has been updated',
    cannotEditTeam: 'This team is read-only',
  },
};
